import { FC, useState } from "react";
import Select from "shared/Select/Select";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useTranslation } from "react-i18next";

export interface PageChooseListingTypeProps { }

const PageChooseListingType: FC<PageChooseListingTypeProps> = () => {
  const { t, ready } = useTranslation("translation");

  const [listingType, setListingType] = useState<String>("");

  function getNextPage() {
    switch (listingType) {
      case "experience":
        return "/host/new-experience/add-listing-1";
      case "property":
        return "/host/new-property/add-listing-1";
      case "holidayPackage":
        return "/host/new-holiday-package/add-listing-1";
      default:
        return "/host/";
    }
  }

  if (!ready) return null;

  return (
    <CommonLayout
      index=""
      backtHref="/host/"
      nextHref={getNextPage()}
      canGoNext={listingType?.length > 0}
    >
      <>
        <h2 className="text-2xl font-semibold">{t("translation:components.hostUploadRouter.title")}</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <div className="space-y-8">
          {/* ITEM */}
          <FormItem
            label={t("translation:components.hostUploadRouter.description")}
            desc=""
          >
            <Select
              defaultValue={""}
              onChange={(e) => setListingType(e.target.value)}
            >
              <option defaultChecked value={""}>{t("translation:components.hostUploadRouter.options.default.label")}</option>
              <option value={"experience"}>{t("translation:components.hostUploadRouter.options.experience.label")}</option>
              <option value={"property"}>{t("translation:components.hostUploadRouter.options.accommodation.label")}</option>
              <option value={"holidayPackage"}>{t("translation:components.hostUploadRouter.options.holidayPackage.label")}</option>
              <option value={"event"} disabled>{t("translation:components.hostUploadRouter.options.event.label")}</option>
              <option value={"service"} disabled>{t("translation:components.hostUploadRouter.options.service.label")}</option>
            </Select>
          </FormItem>
        </div>
      </>
    </CommonLayout >
  );
};

export default PageChooseListingType;
